const calendarLang = {
  formatYear: "YYYY",
  formatMonth: "MM/YYYY",
  today: "C\u0435\u0433\u043E\u0434\u043D\u044F",
  view: {
    month: "\u043C\u0435\u0441\u044F\u0446",
    year: "\u0433\u043E\u0434",
    week: "\u041D\u0435\u0434\u0435\u043B\u044F",
    day: "\u0434\u0435\u043D\u044C"
  },
  month: {
    long: {
      January: "\u044F\u043D\u0432\u0430\u0440\u044F",
      February: "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
      March: "\u043C\u0430\u0440\u0442\u0430",
      April: "\u0430\u043F\u0440\u0435\u043B\u044F",
      May: "\u043C\u0430\u044F",
      June: "\u0438\u044E\u043D\u044F",
      July: "\u0438\u044E\u043B\u044F",
      August: "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
      September: "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
      October: "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
      November: "\u043D\u043E\u044F\u0431\u0440\u044F",
      December: "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    },
    short: {
      January: "\u044F\u043D\u0432",
      February: "\u0444\u0435\u0432",
      March: "\u043C\u0430\u0440",
      April: "\u0430\u043F\u0440",
      May: "\u043C\u0430\u0439",
      June: "\u0438\u044E\u043D",
      July: "\u0438\u044E\u043B",
      August: "\u0430\u0432\u0433",
      September: "\u0441\u0435\u043D",
      October: "\u043E\u043A\u0442",
      November: "\u043D\u043E\u044F",
      December: "\u0434\u0435\u043A"
    }
  },
  week: {
    long: {
      self: "\u041D\u0435\u0434\u0435\u043B\u044F",
      monday: "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
      tuesday: "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
      wednesday: "\u0441\u0440\u0435\u0434\u0430",
      thursday: "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
      friday: "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
      saturday: "\u0441\u0443\u0431\u0431\u043E\u0442\u0430",
      sunday: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435"
    },
    short: {
      self: "\u041D\u0435\u0434\u0435\u043B\u044F",
      monday: "\u041F\u043D",
      tuesday: "\u0412\u0442",
      wednesday: "\u0421\u0440",
      thursday: "\u0427\u0442",
      friday: "\u041F\u0442",
      saturday: "\u0421\u0431",
      sunday: "\u0412\u0441"
    }
  }
};
const lang = {
  locale: "ru-RU",
  empty: {
    description: "\u043D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"
  },
  drawer: {
    okText: "OK",
    cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430"
  },
  popconfirm: {
    okText: "OK",
    cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430"
  },
  modal: {
    okText: "OK",
    cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430"
  },
  pagination: {
    goto: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438",
    page: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
    countPerPage: "/ \u0441\u0442\u0440.",
    total: "\u0412\u0441\u0435\u0433\u043E {0}"
  },
  table: {
    okText: "OK",
    resetText: "\u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C"
  },
  upload: {
    start: "\u041D\u0430\u0447\u0430\u043B\u043E",
    cancel: "\u041E\u0442\u043C\u0435\u043D\u0430",
    delete: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    retry: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    buttonText: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C",
    preview: "\u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
    drag: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0438\u043B\u0438 \u043F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\u0445 \u0441\u044E\u0434\u0430",
    dragHover: "\u041E\u0441\u0432\u043E\u0431\u043E\u0434\u0438\u0442\u0435 \u0444\u0430\u0439\u043B \u0438 \u043D\u0430\u0447\u043D\u0438\u0442\u0435 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0443",
    error: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043D\u0435 \u0443\u0434\u0430\u043B\u0430\u0441\u044C"
  },
  calendar: calendarLang,
  datePicker: {
    view: calendarLang.view,
    month: calendarLang.month,
    week: calendarLang.week,
    placeholder: {
      date: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
      week: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435\u0434\u0435\u043B\u044E",
      month: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u0435\u0441\u044F\u0446",
      year: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0434",
      quarter: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
      time: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F"
    },
    rangePlaceholder: {
      date: ["\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430", "\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F"],
      week: ["\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u0430\u044F \u043D\u0435\u0434\u0435\u043B\u044F", "\u043A\u043E\u043D\u0435\u0446 \u043D\u0435\u0434\u0435\u043B\u0438"],
      month: ["\u043C\u0435\u0441\u044F\u0446 \u043D\u0430\u0447\u0430\u043B\u0430", "\u043A\u043E\u043D\u0435\u0446 \u043C\u0435\u0441\u044F\u0446\u0430"],
      year: ["\u0433\u043E\u0434 \u043D\u0430\u0447\u0430\u043B\u0430", "\u043A\u043E\u043D\u0435\u0446 \u0433\u043E\u0434\u0430"],
      quarter: ["\u0441\u0442\u0430\u0440\u0442\u043E\u0432\u0430\u044F \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u044C", "\u043A\u043E\u043D\u0435\u0446 \u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430"],
      time: ["\u0432\u0440\u0435\u043C\u044F \u043D\u0430\u0447\u0430\u043B\u0430", "\u0432\u0440\u0435\u043C\u044F \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F"]
    },
    selectTime: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F",
    today: "C\u0435\u0433\u043E\u0434\u043D\u044F",
    now: "\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F",
    ok: "OK"
  },
  image: {
    loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430"
  },
  imagePreview: {
    fullScreen: "\u043F\u043E\u043B\u043D\u043E\u044D\u043A\u0440\u0430\u043D\u043D\u044B\u0439",
    rotateRight: "\u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u043F\u0440\u0430\u0432\u043E",
    rotateLeft: "\u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u043B\u0435\u0432\u043E",
    zoomIn: "\u0443\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C",
    zoomOut: "\u0443\u043C\u0435\u043D\u044C\u0448\u0438\u0442\u044C",
    originalSize: "\u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440"
  },
  typography: {
    copied: "\u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E",
    copy: "\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
    expand: "\u0440\u0430\u0441\u0448\u0438\u0440\u044F\u0442\u044C",
    collapse: "\u0441\u043A\u043B\u0430\u0434\u044B\u0432\u0430\u0442\u044C",
    edit: "\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C"
  },
  form: {
    validateMessages: {
      required: "#{field} \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F",
      type: {
        string: "#{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u043E\u0439",
        number: "#{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C",
        boolean: "#{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0431\u0443\u043B\u0435\u0432\u044B\u043C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u043C (true/false)",
        array: "#{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043C\u0430\u0441\u0441\u0438\u0432\u043E\u043C",
        object: "#{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u043C",
        url: "#{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u043C URL-\u0430\u0434\u0440\u0435\u0441\u043E\u043C",
        email: "#{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u043C email-\u0430\u0434\u0440\u0435\u0441\u043E\u043C",
        ip: "#{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u043C IP-\u0430\u0434\u0440\u0435\u0441\u043E\u043C"
      },
      number: {
        min: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 #{value} \u043C\u0435\u043D\u044C\u0448\u0435 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E\u0433\u043E \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F #{min}",
        max: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 #{value} \u0431\u043E\u043B\u044C\u0448\u0435 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E\u0433\u043E \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F #{max}",
        equal: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0440\u0430\u0432\u043D\u043E #{equal}",
        range: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0432 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D\u0435 \u043E\u0442 #{min} \u0434\u043E #{max}",
        positive: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043F\u043E\u043B\u043E\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u0447\u0438\u0441\u043B\u043E\u043C",
        negative: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u0447\u0438\u0441\u043B\u043E\u043C"
      },
      array: {
        length: "\u0412 #{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C #{length} \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432",
        minLength: "\u041C\u0438\u043D\u0438\u043C\u0443\u043C #{minLength} \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u0432 #{field}",
        maxLength: "\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C #{maxLength} \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u0432 #{field}",
        includes: "#{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C #{includes}",
        deepEqual: "#{field} \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u043E\u0436\u0438\u0434\u0430\u0435\u043C\u043E\u043C\u0443 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E",
        empty: "#{field} \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C"
      },
      string: {
        minLength: "`#{field}` \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 #{minLength} \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
        maxLength: "`#{field}` \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 #{maxLength} \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
        length: "\u0414\u043B\u0438\u043D\u0430 \u0441\u0442\u0440\u043E\u043A\u0438 \u0432 #{field} \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0440\u043E\u0432\u043D\u043E #{length} \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
        match: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432 #{field} \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0442\u0440\u0435\u0431\u0443\u0435\u043C\u043E\u043C\u0443 \u0444\u043E\u0440\u043C\u0430\u0442\u0443",
        uppercase: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432 #{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0432 \u0432\u0435\u0440\u0445\u043D\u0435\u043C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0435",
        lowercase: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432 #{field} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0432 \u043D\u0438\u0436\u043D\u0435\u043C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0435"
      },
      object: {
        deepEqual: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432 #{field} \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 \u043E\u0436\u0438\u0434\u0430\u0435\u043C\u044B\u043C",
        hasKeys: "\u0412 #{field} \u0434\u043E\u043B\u0436\u043D\u044B \u0431\u044B\u0442\u044C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u043A\u043B\u044E\u0447\u0438",
        empty: "#{field} \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u043C"
      },
      boolean: {
        true: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C true",
        false: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C false"
      }
    }
  },
  colorPicker: {
    history: "\u041D\u0435\u0434\u0430\u0432\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0446\u0432\u0435\u0442\u0430",
    preset: "\u0426\u0432\u0435\u0442 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E",
    empty: "\u043D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"
  }
};
export { lang as default };
